module.exports = __webpack_public_path__ + "img/w3_technical_light.4ff15537.png";